export default __webpack_public_path__ + "static/media/newknowledge.8880a1a6.svg";